import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  TextField,
  Button,
  Autocomplete,
  Typography,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid2,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Tabs,
  Tab,
  CircularProgress,
  TablePagination,
  IconButton,
} from "@mui/material";
import { toast } from "sonner";
import { Iconify } from "../Minimal/src/components/iconify";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { TablePaginationCustom } from "../Minimal/src/components/pagination";
import { useTable } from "../Minimal/src/hooks/use-table";
import Header from "../Header";
import Footer from "../Footer";
import CommonDatePicker from "../datepicker/CommonDatePicker";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { API_URL, BASE_URL } from "../Config";
import config from "../common/Config";
import AccountService from "../../services/AccountServices";
import jsPDF from "jspdf";
import "jspdf-autotable";
import InvoicePaymentAllocation from "./InvoicePaymentAllocation";
import { fetchCompanyDetailsV2 } from "../../utils/companyDetailsApi";
import * as XLSX from "xlsx";
import '../common/commonStyles.css';
const CustomerAccounts = () => {
  const [dates, setDates] = useState([null, null]);
  const [reportrange, setReportrange] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState("");
  const accessToken = localStorage.getItem("accessToken");
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("userId");
  const [customerLedger, setCustomerLedger] = useState([]);

  const [customer, setCustomer] = useState({
    name: "",
    accound_no: "",
    route_name: "",
  });
  const [nodataRow, setNodataRow] = useState("");

  const [debtProfile, setDebtProfile] = useState({
    zeroto30Due: "0.00",
    moreThan30DaysDue: 0,
    moreThan60DaysDue: 0,
    moreThan90DaysDue: 0,
    current_outstanding: 0,
    total_due1: 0,
    unallocated_amount: 0,
  });
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showDebitModal, setShowDebitModal] = useState(false);
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);

  const [shopDetails, setShopDetails] = useState(null);
  const [logoBase64, setLogoBase64] = useState(null);

  const [activeTab, setActiveTab] = useState("ordered");
  const [errors, setErrors] = useState({});
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [loadingPaymentDetails, setLoadingPaymentDetails] = useState(false);
  const [companyDetails, setCompanyDetails] = useState(null);

  // Helper to fetch image as base64
  const fetchImageAsBase64 = async (url) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      return null;
    }
  };

  // Fetch logo as base64 when shopDetails.logo changes
  useEffect(() => {
    if (shopDetails && shopDetails.logo) {
      fetchImageAsBase64(shopDetails.logo).then(setLogoBase64);
    }
  }, [shopDetails]);

  const formatNumber = (num) => {
    return parseFloat(num).toFixed(2);
  };

  const searchFormData = () => {
    let startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
    let endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";
    setReportrange(startDate ? startDate + " - " + endDate : "");
    //setShouldLoadPayments(true);
    let customerId = customerInputValue ? customerInputValue.value : "";
    // console.log(customerInputValue ? customerInputValue.value : '');

    if (!customerId) {
      toast.error("Please select customer");
      return;
    }
    loadCustomerLadger(customerId, startDate, endDate);
  };

  const loadCustomerLadger = async (customerId, startDate, endDate) => {
    try {
      const data = await AccountService.fetchCustomerLadger(
        customerId,
        startDate,
        endDate,
        accessToken
      );
      //console.log(data);
      if (Array.isArray(data) && data.length === 0) {
        setCustomer({ name: "", accound_no: "", route_name: "" });
        setDebtProfile({
          zeroto30Due: 0,
          moreThan30DaysDue: 0,
          moreThan60DaysDue: 0,
          moreThan90DaysDue: 0,
          current_outstanding: 0,
          total_due1: 0,
          unallocated_amount: 0,
        });
        setCustomerLedger([]);
        setNodataRow("showinfo");
        return;
      }

      if (data.customer) {
        setCustomer({
          name: data.customer.name,
          accound_no: data.customer.accound_no,
          route_name: data.customer.route_name,
        });
        setDebtProfile({
          zeroto30Due: data.debtProfile.zeroto30Due,
          moreThan30DaysDue: data.debtProfile.moreThan30DaysDue,
          moreThan60DaysDue: data.debtProfile.moreThan60DaysDue,
          moreThan90DaysDue: data.debtProfile.moreThan90DaysDue,
          current_outstanding: data.debtProfile.current_outstanding,
          total_due1: data.debtProfile.total_due1,
          unallocated_amount: data.allocation_amout[0].total,
        });
        setCustomerLedger(data.customer_ledger);
        setNodataRow("");
        // Save shop details if present
        if (data.shop_details) {
          setShopDetails(data.shop_details);
          // logoBase64 will be set by useEffect above
        }
      }
    } catch (error) {
      toast.error("Failed to load customer ledger");
    }
  };

  const fetchCustomerNameOptions = async (inputValue) => {
    if (inputValue.length < 3) {
      return;
    }

    const formData = new FormData();
    formData.append("pattern", inputValue);
    formData.append("platform", "web");
    formData.append("authorization", accessToken);

    const apiSalesRapUrl = `${config.API_URL}/ws-get-customer-list`;
    try {
      const response = await fetch(apiSalesRapUrl, {
        method: "POST",
        headers: {},
        body: formData,
      });

      const data = await response.json();
      const formattedOptions = Array.isArray(data.customer_details)
        ? data.customer_details.map((item) => ({
          label: item.name,
          value: item.id,
        }))
        : [];

      setCustomerOptions(formattedOptions);
    } catch (error) {
      toast.error("Error fetching customer options");
    }
  };
  const handleInputChange = (inputValue) => {
    fetchCustomerNameOptions(inputValue);
  };
  const handleChange = (selectedOption) => {
    setCustomerInputValue(selectedOption);

    if (!selectedOption) {
      // Clear the table and reset related states when the selection is cleared
      setCustomer({ name: "", accound_no: "", route_name: "" });
      setDebtProfile({
        zeroto30Due: "0.00",
        moreThan30DaysDue: 0,
        moreThan60DaysDue: 0,
        moreThan90DaysDue: 0,
        current_outstanding: 0,
        total_due1: 0,
        unallocated_amount: 0,
      });
      setCustomerLedger([]);
      setNodataRow("");
    }
  };

  useEffect(() => {
    if (accessToken === null) {
      window.location.href = BASE_URL;
      return;
    }

    document.title = "Customer Account";
    return () => {
      document.title = "Ebusso";
    };
  }, []);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const company = await fetchCompanyDetailsV2();
        if (company) {
          setCompanyDetails(company);
        }
      } catch {
        setCompanyDetails(null);
      }
    };
    fetchCompanyDetails();
  }, [accessToken]);

  const handleShow = () => {
    setShowPaymentModal(true);
  };

  const handleDebit = () => {
    setShowDebitModal(true);
  };

  const fetchPaymentAllocationDetails = async (paymentId) => {
    setLoadingPaymentDetails(true);
    setPaymentDetails(null);
    try {
      const formData = new FormData();
      formData.append("payment_id", paymentId);

      const response = await fetch(
        `${config.API_URL}/getPaymentAllocationDetails`,
        {
          method: "POST",
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
          body: formData,
        }
      );

      const data = await response.json();
      if (data.success && (data.customer || data.allocations?.length > 0)) {
        setPaymentDetails({
          ...data,
          allocations: data.allocations || [],
          customer: data.customer || null,
        });
        setShowPaymentDetailsModal(true);
      } else {
        toast.info(data.message || "No payment details found");
      }
    } catch (error) {
      toast.error("Failed to fetch payment details");
    } finally {
      setLoadingPaymentDetails(false);
    }
  };

  const handlePaymentAmountClick = (e, paymentId) => {
    e.preventDefault();
    if (paymentId) {
      fetchPaymentAllocationDetails(paymentId);
    }
  };

  const formatAllocationDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return format(date, "dd-MM-yyyy");
    } catch (error) {
      return dateString;
    }
  };

  const handleDownloadPaymentDetailsPDF = async () => {
    if (!paymentDetails) return;

    const doc = new jsPDF();
    const margin = 14;
    let y = 15;

    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 18;

    let logoImg = null;
    try {
      const response = await fetch(logoUrl);
      const blob = await response.blob();
      logoImg = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch {
      logoImg = null;
    }

    if (logoImg) {
      try {
        doc.addImage(logoImg, "PNG", margin, y, logoWidth, logoHeight);
      } catch (e) { }
    }

    const detailsX = margin + logoWidth + 5;
    let detailsY = y + 2;

    const company = companyDetails || shopDetails || {};
    const companyName = company.company_name || company.shop_name || "";
    const addressLines = company.address
      ? company.address.split("|").map((line) => line.trim())
      : [];
    const phone = company.phone || shopDetails?.phone || "";
    const email = company.email || shopDetails?.email || "";
    const companyNo = company.company_no || company.company_reg_no || "";
    const vatNo = company.vat_no || shopDetails?.vat_no || "";
    const website = company.website || shopDetails?.website || "";

    if (companyName) {
      doc.setFontSize(13);
      doc.setFont(undefined, "bold");
      doc.text(companyName, detailsX, detailsY);
      detailsY += 6;

      doc.setFontSize(8);
      doc.setFont(undefined, "normal");
      addressLines.forEach((line) => {
        if (line) {
          doc.text(line, detailsX, detailsY);
          detailsY += 4;
        }
      });

      if (phone || email) {
        detailsY += 2;
        const phoneEmailLine = [];
        if (phone) phoneEmailLine.push(`Phone No : ${phone}`);
        if (email) phoneEmailLine.push(`Email : ${email}`);
        if (phoneEmailLine.length > 0) {
          doc.text(phoneEmailLine.join(" | "), detailsX, detailsY);
          detailsY += 4;
        }
      }

      if (companyNo || vatNo || website) {
        const extraLine = [];
        if (companyNo) extraLine.push(`Company No : ${companyNo}`);
        if (vatNo) extraLine.push(`VAT No : ${vatNo}`);
        if (website) extraLine.push(`Website : ${website}`);
        if (extraLine.length > 0) {
          doc.text(extraLine.join(" | "), detailsX, detailsY);
          detailsY += 4;
        }
      }
    } else {
      doc.setFontSize(13);
      doc.setFont(undefined, "bold");
      doc.text("Payment Details", margin, detailsY);
      detailsY += 6;
    }

    y += logoImg ? logoHeight + 8 : detailsY - y + 4;

    // doc.setDrawColor(0, 0, 0);
    // doc.setLineWidth(0.3);
    // doc.line(margin, y, 200 - margin, y);
    // y += 5;

    if (paymentDetails.customer) {
      const customerName = paymentDetails.customer.customer_name || "";
      const customerId = paymentDetails.customer.customer_account_no || "";
      const customerDisplay = customerId
        ? `${customerName}(${customerId})`
        : customerName;

      const paymentAmount = paymentDetails.customer.payment_amount
        ? parseFloat(paymentDetails.customer.payment_amount).toFixed(2)
        : "";
      const paymentDate = paymentDetails.customer.payment_date
        ? formatAllocationDate(paymentDetails.customer.payment_date)
        : "";

      const customerInfo = [
        [
          {
            content: `Customer: ${customerDisplay}`,
            colSpan: 2,
            styles: { fontStyle: "bold" },
          },
          {
            content: "Payment Amount",
            styles: { fontStyle: "bold", textAlign: "right" },
          },
          paymentAmount,
        ],
        [
          { content: "Phone", styles: { fontStyle: "bold" } },
          paymentDetails.customer.customer_phone || "",
          {
            content: "Payment Date",
            styles: { fontStyle: "bold", textAlign: "right" },
          },
          paymentDate,
        ],
        [
          { content: "Email", styles: { fontStyle: "bold" } },
          paymentDetails.customer.customer_email || "",
          "",
          "",
        ],
      ];

      doc.autoTable({
        body: customerInfo,
        startY: y,
        theme: "grid",
        styles: {
          fontSize: 10,
          cellPadding: 3,
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
        columnStyles: {
          0: { cellWidth: 75 },
          1: { cellWidth: 40 },
          2: { cellWidth: 35 },
          3: { cellWidth: 35, halign: "right" },
        },
        didParseCell: function (data) {
          // Make only "Phone" and "Email" keys smaller
          if (
            data.column.index === 0 &&
            (data.row.index === 1 || data.row.index === 2)
          ) {
            data.cell.styles.fontSize = 8;
            data.cell.styles.cellWidth = 10;
          }

          // Keep bold style
          if (
            data.cell.raw &&
            data.cell.raw.styles &&
            data.cell.raw.styles.fontStyle === "bold"
          ) {
            data.cell.styles.fontStyle = "bold";
          }

          // Align last column right
          if (data.column.index === 3) {
            data.cell.styles.halign = "right";
          }
        },
      });

      y = doc.lastAutoTable.finalY + 5;
    }

    if (paymentDetails.allocations && paymentDetails.allocations.length > 0) {
      const tableColumn = [
        "Sr. No.",
        "Allocation Date",
        "Invoice No",
        "Grand Total",
        "Allocated Amount",
        "Source",
      ];
      const tableRows = [];

      paymentDetails.allocations.forEach((allocation, index) => {
        tableRows.push([
          index + 1,
          formatAllocationDate(allocation.allocation_date),
          allocation.invoice_no || "",
          parseFloat(allocation.grand_total || 0).toFixed(2),
          parseFloat(allocation.allocated_amount || 0).toFixed(2),
          allocation.source || "",
        ]);
      });

      const totalGrand = tableRows.reduce(
        (sum, r) => sum + parseFloat(r[3] || 0),
        0
      );
      const totalAllocated = tableRows.reduce(
        (sum, r) => sum + parseFloat(r[4] || 0),
        0
      );

      tableRows.push([
        "",
        "",
        {
          content: "Total",
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: totalGrand.toFixed(2),
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: totalAllocated.toFixed(2),
          styles: { halign: "right", fontStyle: "bold" },
        },
        "",
      ]);

      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: y,
        styles: {
          fontSize: 9,
          cellPadding: 2.5,
          lineWidth: 0.3,
          lineColor: [0, 0, 0],
        },
        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fontStyle: "bold",
        },
        columnStyles: {
          0: { cellWidth: 20, halign: "center" },
          1: { cellWidth: 38 },
          2: { cellWidth: 35 },
          3: { cellWidth: 35, halign: "right" },
          4: { cellWidth: 35, halign: "right" },
          5: { cellWidth: 27 },
        },
        didParseCell: function (data) {
          if (data.row.index === tableRows.length - 1) {
            if (
              data.column.index === 2 ||
              data.column.index === 3 ||
              data.column.index === 4
            ) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.halign = "right";
            }
          }
          if (
            [3, 4].includes(data.column.index) &&
            data.row.index < tableRows.length - 1
          ) {
            data.cell.styles.halign = "right";
          }
        },
      });
    } else {
      doc.setFontSize(10);
      doc.setFont(undefined, "normal");
      doc.text(
        paymentDetails.message || "No allocations found for this payment",
        margin,
        y + 5
      );
    }

    const fileName = `payment_details_${paymentDetails.payment_id || new Date().toISOString().split("T")[0]}.pdf`;
    doc.save(fileName);
  };

  const [payDate, setPayDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [paymentType, setPaymentType] = useState("");
  const [chequeNo, setChequeNo] = useState("");
  const [payAmount, setPayAmount] = useState("");
  const [reference, setReference] = useState("");
  const [isChequeVisible, setChequeVisible] = useState(false);
  const paymentSubmitInFlightRef = useRef(false);
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);

  const handlePaymentTypeChange = (e) => {
    const selectedType = e.target.value;
    setPaymentType(selectedType);
    setChequeVisible(selectedType === "Cheque");
    setErrors((prev) => ({ ...prev, paymentType: "" }));
  };

  const handleCustomerPaymentSubmit = async (event) => {
    event.preventDefault();
    if (paymentSubmitInFlightRef.current) {
      return;
    }

    const localErrors = {};
    if (!payDate || String(payDate).trim() === "") {
      localErrors.payDate = "Date is required.";
    }
    if (!paymentType || String(paymentType).trim() === "") {
      localErrors.paymentType = "Payment Type is required.";
    }
    if (payAmount === "" || isNaN(Number(payAmount))) {
      localErrors.payAmount = "Amount is required.";
    } else if (Number(payAmount) <= 0) {
      if (Number(payAmount) < 0) {
        localErrors.payAmount = "Negative amount is not allowed.";
      } else {
        localErrors.payAmount = "Amount must be greater than 0.";
      }
    }

    if (Object.keys(localErrors).length > 0) {
      setErrors(localErrors);
      return;
    }

    paymentSubmitInFlightRef.current = true;
    setIsSubmittingPayment(true);

    let startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
    let endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("customer_id", customerInputValue.value);
    formData.append("date", payDate);
    formData.append("amount", payAmount);
    formData.append("paid_by", paymentType);
    formData.append("reference_no", reference);
    formData.append("cheque_no", chequeNo);

    const apiBrandUrl = `${config.API_URL}/payments/add_payment`;
    try {
      const response = await fetch(apiBrandUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to add payment");
      }

      const data = await response.json();

      const msg = data.message;

      if (data.success) {
        setShowPaymentModal(false);
        toast.success("Payment added successfully.");
        setPayDate(new Date().toISOString().split("T")[0]);
        setPaymentType("");
        setChequeNo("");
        setPayAmount("");
        setReference("");
        setChequeVisible(false);
        setErrors({});
        loadCustomerLadger(customerInputValue?.value, startDate, endDate);
      } else {
        toast.error(msg);
      }
    } catch (error) {
      console.error("Error adding payment:", error);
    } finally {
      paymentSubmitInFlightRef.current = false;
      setIsSubmittingPayment(false);
    }
  };

  const handleDebitNoteSubmit = async (event) => {
    event.preventDefault();

    // Inline validation (no Swal)
    const localErrors = {};
    if (!payDate || String(payDate).trim() === "") {
      localErrors.payDate = "Date is required.";
    }
    if (
      payAmount === "" ||
      isNaN(Number(payAmount)) ||
      Number(payAmount) <= 0
    ) {
      localErrors.payAmount = "Amount is required.";
    }
    if (Object.keys(localErrors).length > 0) {
      setErrors(localErrors);
      return;
    }

    let startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
    let endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";

    const formData = new FormData();
    formData.append("user_id", user_id);
    formData.append("customer_id", customerInputValue.value);
    formData.append("date", payDate);
    formData.append("amount", payAmount);
    //formData.append('paid_by', paymentType);
    formData.append("reference_no", reference);
    formData.append("cheque_no", chequeNo);

    const apiBrandUrl = `${config.API_URL}/payments/add_debit_note`;
    try {
      const response = await fetch(apiBrandUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Failed to add payment");
      }

      const data = await response.json();
      console.log(data);
      const msg = data.message;

      if (data.success) {
        setShowDebitModal(false);
        toast.success("Debit note added successfully.");
        setPayDate(new Date().toISOString().split("T")[0]);
        setPaymentType("");
        setChequeNo("");
        setPayAmount("");
        setReference("");
        setChequeVisible(false);
        setErrors({});
        loadCustomerLadger(customerInputValue?.value, startDate, endDate);
      } else {
        toast.error(msg);
      }
    } catch (error) {
      toast.error("Error adding debit note");
    }
  };

  // PDF Export Handler
  const handlePrintPDF = async () => {
    const doc = new jsPDF();
    const margin = 14;
    let y = 15;

    // Use custom logo URL
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 40;
    const logoHeight = 18;

    // Fetch logo as base64 for jsPDF
    let logoImg = logoBase64;
    if (!logoImg) {
      try {
        const response = await fetch(logoUrl);
        const blob = await response.blob();
        logoImg = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(blob);
        });
      } catch {
        logoImg = null;
      }
    }

    // Draw logo
    if (logoUrl) {
      try {
        doc.addImage(logoUrl, "PNG", margin, y, logoWidth, logoHeight);
        // Do not increment y yet, as details will be on the right
      } catch (e) {
        // If image fails, skip
      }
    }

    // Draw shop details to the right of the logo
    if (shopDetails) {
      const detailsX = margin + logoWidth + 5;
      let detailsY = y + 2;

      doc.setFontSize(13);
      doc.setFont(undefined, "bold");
      doc.text(shopDetails.shop_name || "", detailsX, detailsY);
      detailsY += 6;

      doc.setFontSize(8);
      doc.setFont(undefined, "normal");
      if (shopDetails.address) {
        doc.text(shopDetails.address.split(","), detailsX, detailsY);

        detailsY += 8;
      }

      let phoneEmail = [];
      if (shopDetails.phone) phoneEmail.push(`Phone No : ${shopDetails.phone}`);
      if (shopDetails.email) phoneEmail.push(`Email : ${shopDetails.email}`);
      if (phoneEmail.length > 0) {
        doc.text(phoneEmail.join(" | "), detailsX, detailsY);
        detailsY += 5;
      }
      let companyVat = [];
      if (shopDetails.company_reg_no)
        companyVat.push(`Company No : ${shopDetails.company_reg_no}`);
      if (shopDetails.vat_no) companyVat.push(`VAT No : ${shopDetails.vat_no}`);
      if (shopDetails.website)
        companyVat.push(`Website : ${shopDetails.website}`);
      if (companyVat.length > 0) {
        doc.text(companyVat.join(" | "), detailsX, detailsY);
        detailsY += 5;
      }

      // After logo/details block, move y below the logo or details, whichever is lower
      y += logoImg ? logoHeight + 2 : detailsY - y;
    }

    // let customerTitle = customer && customer.name ? `Customer Ledger - ${customer.name} (${customer.accound_no})` : "Customer Ledger";
    // doc.setFontSize(14);
    // doc.text(customerTitle, margin, y);
    y += 6;

    // Add summary table (the section you referenced)
    const summaryRows = [
      [
        {
          content: `Customer: ${customer.name} (${customer.accound_no})`,
          colSpan: 2,
          styles: { fontStyle: "bold" },
        },
        {
          content: "0 to 30 Days",
          styles: { fontStyle: "bold", textAlign: "right" },
        },
        { content: debtProfile.zeroto30Due },
      ],
      [
        { content: "Current Bal", styles: { fontStyle: "bold" } },
        debtProfile.current_outstanding,
        {
          content: "30 + Days",
          styles: { fontStyle: "bold", textAlign: "right" },
        },
        debtProfile.moreThan30DaysDue,
      ],
      [
        { content: "Amount Due", styles: { fontStyle: "bold" } },
        debtProfile.total_due1,
        { content: "60 + Days", styles: { fontStyle: "bold" } },
        debtProfile.moreThan60DaysDue,
      ],
      [
        { content: "", styles: { fontStyle: "bold" } },
        ,
        { content: "90 + Days", styles: { fontStyle: "bold" } },
        debtProfile.moreThan90DaysDue,
      ],
    ];

    doc.autoTable({
      body: summaryRows,
      startY: y,
      theme: "grid",
      styles: {
        fontSize: 10,
        cellPadding: 2,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 70 },
        1: { cellWidth: 35 },
        2: { cellWidth: 40 },
        3: { cellWidth: 35, halign: "right" }, // Right align last column (amount/balance)
      },
      didParseCell: function (data) {
        if (
          data.cell.raw &&
          data.cell.raw.styles &&
          data.cell.raw.styles.fontStyle === "bold"
        ) {
          data.cell.styles.fontStyle = "bold";
        }
        // Right align amount/balance columns for summary table
        if (data.column.index === 1 || data.column.index === 3) {
          data.cell.styles.halign = "right";
        }
      },
    });

    // Ledger table for PDF
    const tableColumn = [
      "Date",
      "Inv No",
      "Status",
      "Type",
      "Cr",
      "Dr",
      "Balance",
    ];
    const tableRows = [];

    let runningBalance = 0;
    const sortedLedger = [...customerLedger].sort((a, b) => {
      const parseDMY = (str) => {
        if (!str) return new Date(0);
        const [day, month, year] = str.split("-");
        return new Date(`${year}-${month}-${day}`);
      };
      const dateA = parseDMY(a.date);
      const dateB = parseDMY(b.date);
      return dateA - dateB;
    });

    sortedLedger.forEach((item) => {
      const {
        date,
        particulars,
        reference_number,
        payment_status,
        payment_type,
        paid_by,
        orderId,
        amount,
      } = item;

      let invNo = "";
      let status = "";
      let type = "";
      let cr = "";
      let dr = "";

      // Hide "Opening Balance" if accessToken is 'eve'
      if (particulars === "Opening Balance" && accessToken === "eve") {
        return; // Skip this row
      }

      if (particulars === "Initial Balance") {
        invNo = "Initial Balance";
      } else if (particulars === "Opening Balance") {
        invNo = "Opening Balance";
      } else if (payment_type === "c") {
        type =
          paid_by &&
            paid_by !== "NULL" &&
            paid_by.trim() !== "" &&
            paid_by.trim() !== "0"
            ? paid_by
            : particulars;
      } else if (payment_type === "d") {
        invNo = orderId && orderId !== "0" ? particulars : particulars;
        status =
          payment_status === "Paid"
            ? "Paid"
            : payment_status === "Due"
              ? "UnPaid"
              : payment_status === "Partial"
                ? "Partial Paid"
                : payment_status;
        type = "Invoice";
      } else {
        invNo = particulars && particulars !== "_" ? particulars : "";
      }

      // Set Cr/Dr columns based on payment_type
      const amountFormatted = !isNaN(parseFloat(amount))
        ? parseFloat(amount).toFixed(2)
        : "";
      if (payment_type === "c") {
        cr = amountFormatted;
        dr = "";
        runningBalance -= parseFloat(amountFormatted);
      } else if (payment_type === "d") {
        cr = "";
        dr = amountFormatted;
        runningBalance += parseFloat(amountFormatted);
      } else {
        cr = "";
        dr = "";
      }

      // For opening/initial balance, set runningBalance
      if (
        particulars === "Initial Balance" ||
        particulars === "Opening Balance"
      ) {
        runningBalance = parseFloat(amountFormatted);
      }
      if (particulars === "Opening Balance") {
        runningBalance = parseFloat(0.0);
      }
      const balanceFormatted = !isNaN(runningBalance)
        ? runningBalance.toFixed(2)
        : "";

      tableRows.push([
        date || "",
        invNo || "",
        status || "",
        type || "",
        cr,
        dr,
        balanceFormatted,
      ]);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: doc.lastAutoTable.finalY + 5,
      styles: {
        lineWidth: 0.3,
        lineColor: [0, 0, 0], // black border
      },
      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
      },
      columnStyles: {
        0: { cellWidth: 25 },
        1: { cellWidth: 35 },
        2: { cellWidth: 20 },
        3: { cellWidth: 40 },
        4: { cellWidth: 20, halign: "right" }, // Cr right
        5: { cellWidth: 20, halign: "right" }, // Dr right
        6: { cellWidth: 20, halign: "right" }, // Balance right
      },
    });
    doc.save("customer_ledger.pdf");
  };

  // --- START: AmountDueCustomerList logic and state ---
  const [salesDates, setSalesDates] = useState([null, null]);

  const table = useTable({
    defaultRowsPerPage: 10,
    defaultDense: false,
    defaultOrder: "desc",
    defaultOrderBy: "date",
    defaultSelected: [],
    defaultCurrentPage: 0,
  });

  const handleAmountDueSubmit = (e) => {
    e.preventDefault();

    getSalesOrderList();
  };

  const handleSendEmail = async (customerId) => {
    try {
      const apiUrl = `${config.API_URL}/send_due_email`;
      const formData = new FormData();
      formData.append("customer_id", customerId);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        toast.success("Email sent successfully!");
      } else {
        toast.error("Failed to send email.");
      }
    } catch (error) {
      toast.error("Failed to send email.");
    }
  };

  const [amountDueCustomers, setAmountDueCustomers] = useState([]);
  const [amountDueTotals, setAmountDueTotals] = useState({
    c_balance: 0,
    total_due: 0,
    zero_to_30: 0,
    thirty_plus: 0,
    sixty_plus: 0,
    ninety_plus: 0,
  });
  const [amountDuePage, setAmountDuePage] = useState(0);
  const [amountDueRowsPerPage, setAmountDueRowsPerPage] = useState(50);
  const [amountDueLoading, setAmountDueLoading] = useState(false);

  const getSalesOrderList = async () => {
    setAmountDueLoading(true);
    try {
      const formData = new FormData();
      formData.append("draw", 1);
      formData.append("start", amountDuePage * amountDueRowsPerPage);
      formData.append("length", amountDueRowsPerPage);
      const [startDate, endDate] = salesDates;
      let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
      let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
      if (formattedStartDate) formData.append("searchByFromdate", formattedStartDate);
      if (formattedEndDate) formData.append("searchByTodate", formattedEndDate);

      const response = await fetch(`${config.API_URL}/get_amtDueCustomer`, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const json = await response.json();
      if (json.totals) {
        setAmountDueTotals({
          c_balance: json.data
            ? json.data.reduce((sum, row) => sum + parseFloat(row.cBalances || 0), 0).toFixed(2)
            : "0.00",
          total_due: json.data
            ? json.data.reduce((sum, row) => sum + parseFloat(row.total_due || 0), 0).toFixed(2)
            : "0.00",
          zero_to_30: json.totals.sum_get_dues_zero_to_30 || "0.00",
          thirty_plus: json.totals.sum_get_dues_30 || "0.00",
          sixty_plus: json.totals.sum_get_dues_60 || "0.00",
          ninety_plus: json.totals.sum_get_dues_90 || "0.00",
        });
      }
      setAmountDueCustomers(Array.isArray(json.data) ? json.data : []);
    } catch (error) {
      toast.error("Failed to load amount due customers");
    } finally {
      setAmountDueLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === "received") {
      getSalesOrderList();
    }
  }, [activeTab, amountDuePage, amountDueRowsPerPage, salesDates]);


  const handleExport = async () => {
    try {
      const apiUrl = `${config.API_URL}/get_amtDueCustomer`;
      const formData = new FormData();
      formData.append("draw", 1);
      formData.append("start", 0);
      formData.append("length", 1000000);
      const [startDate, endDate] = salesDates;
      let formattedStartDate = startDate ? format(startDate, "MM/dd/yyyy") : "";
      let formattedEndDate = endDate ? format(endDate, "MM/dd/yyyy") : "";
      if (formattedStartDate)
        formData.append("searchByFromdate", formattedStartDate);
      if (formattedEndDate) formData.append("searchByTodate", formattedEndDate);

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });
      const result = await response.json();

      const allData = Array.isArray(result.data) ? result.data : [];

      const wsData = [
        [
          "Sr. No.",
          "Customer Name(Ac/No)",
          "account_no",
          "C Balance",
          "Amount Due",
          "0 to 30 Days",
          "30 + Days",
          "60 + Days",
          "90 + Days",
        ],
        ...allData.map((row, idx) => [
          idx + 1,
          row.customer_name,
          row.account_no,
          parseFloat(row.cBalances),
          parseFloat(row.total_due),
          parseFloat(row.get_dues_zero_to_30),
          parseFloat(row.get_dues_30),
          parseFloat(row.get_dues_60),
          parseFloat(row.get_dues_90),
        ]),
      ];

      const ws = XLSX.utils.aoa_to_sheet(wsData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "AmountDueCustomers");
      XLSX.writeFile(wb, "AmountDueCustomers.xlsx");
      toast.success("Data exported successfully");
    } catch (err) {
      toast.error("Failed to export all data.");
    }
  };

  // --- END: AmountDueCustomerList logic and state ---

  // Add state for allocation modal
  const [showAllocationModal, setShowAllocationModal] = useState(false);
  const [allocationCustomerId, setAllocationCustomerId] = useState(null);

  // Handler to open modal
  const handleOpenAllocationModal = (customerId) => {
    setAllocationCustomerId(customerId);
    setShowAllocationModal(true);
  };

  // Handler to close modal
  const handleCloseAllocationModal = () => {
    setShowAllocationModal(false);
    setAllocationCustomerId(null);
  };

  const displayedCustomerLedger = useMemo(() => {
    return Array.isArray(customerLedger) ? customerLedger : [];
  }, [customerLedger]);

  // Excel Export Handler
  const handleExportToExcel = () => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Prepare data for Excel
    const excelData = [];

    // Add company/shop details at the top
    const company = companyDetails || shopDetails || {};
    const companyName = company.company_name || company.shop_name || "";
    if (companyName) {
      excelData.push([companyName]);
      excelData.push([]); // Empty row

      if (company.address) {
        const addressLines = company.address.split("|").map((line) => line.trim()).filter(line => line);
        addressLines.forEach((line) => {
          excelData.push([line]);
        });
      }

      const contactInfo = [];
      if (company.phone || shopDetails?.phone) contactInfo.push(`Phone No : ${company.phone || shopDetails?.phone}`);
      if (company.email || shopDetails?.email) contactInfo.push(`Email : ${company.email || shopDetails?.email}`);
      if (contactInfo.length > 0) {
        excelData.push([contactInfo.join(" | ")]);
      }

      const extraInfo = [];
      if (company.company_no || company.company_reg_no) extraInfo.push(`Company No : ${company.company_no || company.company_reg_no}`);
      if (company.vat_no || shopDetails?.vat_no) extraInfo.push(`VAT No : ${company.vat_no || shopDetails?.vat_no}`);
      if (company.website || shopDetails?.website) extraInfo.push(`Website : ${company.website || shopDetails?.website}`);
      if (extraInfo.length > 0) {
        excelData.push([extraInfo.join(" | ")]);
      }
      excelData.push([]); // Empty row
    }

    // Add summary table
    excelData.push(["Customer:", `${customer.name} (${customer.accound_no})`, "", "0 to 30 Days:", debtProfile.zeroto30Due]);
    excelData.push(["Current Bal:", debtProfile.current_outstanding, "", "30 + Days:", debtProfile.moreThan30DaysDue]);
    excelData.push(["Amount Due:", debtProfile.total_due1, "", "60 + Days:", debtProfile.moreThan60DaysDue]);
    excelData.push(["", "", "", "90 + Days:", debtProfile.moreThan90DaysDue]);
    excelData.push([]); // Empty row

    // Add ledger table headers
    excelData.push(["Date", "Inv No", "Status", "Type", "Cr", "Dr", "Balance"]);

    // Process ledger data (same logic as PDF)
    let runningBalance = 0;
    const sortedLedger = [...customerLedger].sort((a, b) => {
      const parseDMY = (str) => {
        if (!str) return new Date(0);
        const [day, month, year] = str.split("-");
        return new Date(`${year}-${month}-${day}`);
      };
      const dateA = parseDMY(a.date);
      const dateB = parseDMY(b.date);
      return dateA - dateB;
    });

    sortedLedger.forEach((item) => {
      const {
        date,
        particulars,
        reference_number,
        payment_status,
        payment_type,
        paid_by,
        orderId,
        amount,
      } = item;

      let invNo = "";
      let status = "";
      let type = "";
      let cr = "";
      let dr = "";

      // Hide "Opening Balance" if accessToken is 'eve'
      if (particulars === "Opening Balance" && accessToken === "eve") {
        return; // Skip this row
      }

      if (particulars === "Initial Balance") {
        invNo = "Initial Balance";
      } else if (particulars === "Opening Balance") {
        invNo = "Opening Balance";
      } else if (payment_type === "c") {
        type =
          paid_by &&
            paid_by !== "NULL" &&
            paid_by.trim() !== "" &&
            paid_by.trim() !== "0"
            ? paid_by
            : particulars;
      } else if (payment_type === "d") {
        invNo = orderId && orderId !== "0" ? particulars : particulars;
        status =
          payment_status === "Paid"
            ? "Paid"
            : payment_status === "Due"
              ? "UnPaid"
              : payment_status === "Partial"
                ? "Partial Paid"
                : payment_status;
        type = "Invoice";
      } else {
        invNo = particulars && particulars !== "_" ? particulars : "";
      }

      if (particulars === "Debit Note") {
        type = "Debit Note";
      }
      if (particulars === "Credit Note") {
        invNo = reference_number || "";
        type = "Credit Note";
      }

      // Set Cr/Dr columns based on payment_type
      const amountFormatted = !isNaN(parseFloat(amount))
        ? parseFloat(amount).toFixed(2)
        : "";
      if (payment_type === "c") {
        cr = amountFormatted ? parseFloat(amountFormatted) : "";
        dr = "";
        runningBalance -= parseFloat(amountFormatted || 0);
      } else if (payment_type === "d") {
        cr = "";
        dr = amountFormatted ? parseFloat(amountFormatted) : "";
        runningBalance += parseFloat(amountFormatted || 0);
      } else {
        cr = "";
        dr = "";
      }

      // For opening/initial balance, set runningBalance
      if (
        particulars === "Initial Balance" ||
        particulars === "Opening Balance"
      ) {
        runningBalance = parseFloat(amountFormatted || 0);
      }
      if (particulars === "Opening Balance") {
        runningBalance = parseFloat(0.0);
      }
      const balanceFormatted = !isNaN(runningBalance)
        ? runningBalance.toFixed(2)
        : "";

      excelData.push([
        date || "",
        invNo || "",
        status || "",
        type || "",
        cr || "",
        dr || "",
        balanceFormatted ? parseFloat(balanceFormatted) : "",
      ]);
    });

    // Create worksheet from data
    const ws = XLSX.utils.aoa_to_sheet(excelData);

    // Set column widths
    ws["!cols"] = [
      { wch: 15 }, // Date
      { wch: 20 }, // Inv No
      { wch: 12 }, // Status
      { wch: 20 }, // Type
      { wch: 15 }, // Cr
      { wch: 15 }, // Dr
      { wch: 15 }, // Balance
    ];

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, "Customer Ledger");

    // Generate filename with customer name if available
    const fileName = customer.name
      ? `Customer_Ledger_${customer.name.replace(/[^a-z0-9]/gi, "_")}_${customer.accound_no}.xlsx`
      : "customer_ledger.xlsx";

    // Write and save file
    XLSX.writeFile(wb, fileName);
  };

  return (
    <>
      <Box className="page-container">
        <Paper className="paper-style">
          <Box sx={{ px: 2, py: 1.2 }} display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={1} justifyContent="space-between" alignItems="center">
            <Tabs
              value={activeTab}
              onChange={(e, newValue) => {
                setActiveTab(newValue);
                if (newValue === "received") {
                  getSalesOrderList();
                }
              }}
              className="common-tabs"
            >
              <Tab label="Customer Ledger" value="ordered" />
              <Tab label="Amount Due Customers" value="received" />
            </Tabs>

            {activeTab === "received" && (
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  onClick={handleExport}
                  className="button-variant-contained"
                  sx={{ width: { xs: '100%', md: 'auto' },
                
                }}
                >
                  Export
                </Button>
              </Box>
            )}
          </Box>
          <Box sx={{py:1}}>
            {activeTab === "ordered" && (
              <>
              <Box sx={{px: 2}}>
                <Grid2 container spacing={2} display="flex" justifyContent="space-between" alignItems="center">
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Autocomplete
                      options={customerOptions}
                      value={customerInputValue}
                      onChange={(event, newValue) => handleChange(newValue)}
                      onInputChange={(event, newInputValue) => handleInputChange(newInputValue)}
                      isOptionEqualToValue={(option, value) => option.value === value?.value}
                      getOptionLabel={(option) => option.label || ""}
                      renderInput={(params) => (
                        <TextField
                          className="input-border"
                          {...params}
                          placeholder="Search customer..."
                          size="small"
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              backgroundColor: "#f5f7fa",
                              fontSize: "0.875rem",
                              "&:hover": {
                                backgroundColor: "#fff",
                              },
                              "&.Mui-focused": {
                                backgroundColor: "#fff",
                              },
                            },
                            "& .MuiInputLabel-root": {
                              fontSize: "0.875rem",
                            },
                          }}
                        />
                      )}
                      sx={{
                        "& .MuiAutocomplete-popper": {
                          zIndex: 9999,
                        },
                      }}
                    />
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    <Stack direction="row" spacing={1} alignItems="center" flexDirection={{ xs: 'column', md: 'row' }}>
                      <Box sx={{ width: { xs: '100%', md: '310px' } }}>
                        <CommonDatePicker value={dates} onChange={setDates}
                          className="input-border" 
                        />
                      </Box>
                      <Button
                        variant="contained"
                        onClick={searchFormData}
                        className="button-variant-contained"
                        sx={{ width: { xs: '100%', md: 'auto' } }}
                      >
                        Submit
                      </Button>
                    </Stack>
                  </Grid2>
                  <Grid2 size={{ xs: 12, md: 4 }}>
                    {customer.name && (
                      <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
                        <Button
                          variant="contained"
                          onClick={handleShow}
                          className="button-variant-contained"
                        >
                          Add Payment
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={handlePrintPDF}
                          className="button-variant-outlined"
                          
                        >
                          Print PDF
                        </Button>
                        <Button
                          variant="outlined"
                          onClick={handleExportToExcel}
                          className="button-variant-outlined"
                          
                        >
                          Export
                        </Button>
                      </Stack>
                    )}
                  </Grid2>
                </Grid2>

                {customer.name && (
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 1,
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      my: 1,
                      width:{ xs: "100%", md: "60%" },
                    }}
                  >

                    <TableContainer>
                      <Table
                        className="table-cell-border"
                      >
                        <TableBody sx={{
                          "& .MuiTableCell-root": {
                            fontSize: "0.75rem",
                            color: "#212b36",
                            py: 1,
                            borderRight: "1px dashed #c4c4c4 !important",
                          },
                          "& .MuiTableCell-root:last-child": {
                            borderRight: "none !important",
                          },
                        }}>
                          <TableRow >
                            <TableCell colSpan={2} sx={{ py: 1.2, fontWeight: 600, backgroundColor: "#f5f7fa"}}>
                              {customer.name}({customer.accound_no})
                            </TableCell>
                            <TableCell sx={{ py: 1 }}>0 To 30 Days</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.zeroto30Due}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ py: 1 }}>C. Bal</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.current_outstanding}</TableCell>
                            <TableCell sx={{ py: 1 }}>30 + Days</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.moreThan30DaysDue}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ py: 1 }}>Amt. Due</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.total_due1}</TableCell>
                            <TableCell sx={{ py: 1 }}>60 + Days</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.moreThan60DaysDue}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ py: 1 }}>Unallocated Amount</TableCell>
                            <TableCell sx={{ textAlign: "right", py: 1 }}>
                              <Typography
                                component="a"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleOpenAllocationModal(customerInputValue?.value);
                                }}
                                sx={{
                                  color: "#212b36",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                  fontSize: "0.875rem",
                                  "&:hover": { textDecoration: "underline" },
                                  textDecoration: 'underline !important',
                                }}
                              >
                                {Number(debtProfile.unallocated_amount).toFixed(2)}
                              </Typography>
                            </TableCell>
                                          
                           <TableCell sx={{ py: 1 }}>90 + Days</TableCell>
                           <TableCell sx={{ textAlign: "right", py: 1 }}>{debtProfile.moreThan90DaysDue}</TableCell>
                          </TableRow>

                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                )}
                {customerLedger.length > 0 && (
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 1,
                      border: "1px solid rgba(145, 158, 171, 0.16)",
                      overflow: "hidden",
                      backgroundColor: "#fff",
                      width:{ xs: "100%", md: "60%" },
                    }}
                  >
                    <TableContainer
                      sx={{
                        maxHeight: "60vh",
                        overflow: "auto",
                      }}
                    >
                      <Table
                        size="medium"
                        className="table-cell-border"
                        sx={{
                          tableLayout: "fixed", width: "100%"
                        }}
                       
                      >
                        <TableHead>
                          <TableRow className="table-cell-header">
                            <TableCell sx={{ width: "80px" }}>Date</TableCell>
                            <TableCell sx={{ width: "100px" }}>Inv No</TableCell>
                            <TableCell sx={{ width: "100px" }}>Type</TableCell>
                            <TableCell sx={{ width: "70px" }}>Status</TableCell>
                    
                            <TableCell sx={{ width: "70px", textAlign: "right" }}>Credit</TableCell>
                            <TableCell sx={{ width: "70px", textAlign: "right" }}>Debit</TableCell>
                            <TableCell sx={{ width: "80px", textAlign: "right" }}>Balance</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedCustomerLedger.map((item, index) => {
                            const {
                              id,
                              date,
                              payment_type,
                              amount,
                              balance,
                              reference_number,
                              payment_status,
                              particulars,
                              paid_by,
                              orderId,
                            } = item;

                            const amountFormatted = !isNaN(
                              parseFloat(amount)
                            )
                              ? parseFloat(amount).toFixed(2)
                              : "";
                            const balanceFormatted = !isNaN(
                              parseFloat(balance)
                            )
                              ? parseFloat(balance).toFixed(2)
                              : "";

                            let rowDate = date;
                            let invNo = "";
                            let status = "";
                            let type = "";
                            let cr = "";
                            let dr = "";
                            let bgColor = "";

                            if (particulars === "Initial Balance") {
                              invNo = "Initial Balance";
                            } else if (particulars === "Opening Balance") {
                              invNo = "Opening Balance";
                              bgColor = "#dcf2d8";
                            } else if (payment_type === "c") {
                              type =
                                paid_by &&
                                  paid_by !== "NULL" &&
                                  paid_by.trim() !== "" &&
                                  paid_by.trim() !== "0"
                                  ? paid_by
                                  : particulars;
                              bgColor = "#dcf2d8";
                            } else if (payment_type === "d") {
                              invNo =
                                orderId && orderId !== "0" ? (
                                  <a
                                    href={`${config.BASE_URL}/trip_summary/print/${orderId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {particulars}
                                  </a>
                                ) : (
                                  particulars
                                );
                              status =
                                payment_status === "Paid"
                                  ? "Paid"
                                  : payment_status === "Due"
                                    ? "UnPaid"
                                    : payment_status === "Partial"
                                      ? "Partial Paid"
                                      : payment_status;
                              type = "Invoice";
                            } else {
                              invNo =
                                particulars && particulars !== "_"
                                  ? particulars
                                  : "";
                            }

                            if (particulars === "Debit Note") {
                              type = "Debit Note";
                            }
                            if (particulars === "Credit Note") {
                              let cleanNumber = reference_number.replace(
                                /^PR0*/,
                                ""
                              );
                              invNo =
                                cleanNumber && cleanNumber !== "0" ? (
                                  <a
                                    href={`${config.BASE_URL}/returns/view/${cleanNumber}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {reference_number}
                                  </a>
                                ) : (
                                  reference_number
                                );
                              type = "Credit Note";
                            }
                            // Set Cr/Dr columns based on payment_type
                            if (payment_type === "c") {
                              cr = (
                                <a
                                  href="#"
                                  onClick={(e) =>
                                    handlePaymentAmountClick(e, id)
                                  }
                                  style={{
                                    color: "inherit",
                                    textDecoration: "none",
                                    cursor: "pointer",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.target.style.textDecoration =
                                      "underline";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.target.style.textDecoration = "none";
                                  }}
                                >
                                  {amountFormatted}
                                </a>
                              );
                              dr = "";
                            } else if (payment_type === "d") {
                              cr = "";
                              dr = amountFormatted;
                            } else {
                              cr = "";
                              dr = "";
                            }

                            return (
                              <TableRow
                                key={`${id}-${index}`}
                                hover
                                sx={{
                                  backgroundColor: bgColor || "transparent",
                                  "&:hover": {
                                    backgroundColor: bgColor || "rgba(145, 158, 171, 0.04)"
                                  },

                                  transition: "background-color 0.2s ease",
                                  '& .MuiTableCell-root': {
                                    fontSize: "0.75rem",
                                    color: "#212b36",
                                    py: 1,
                                  }
                                }}
                              >
                                <TableCell>
                                  {rowDate}
                                </TableCell>
                                <TableCell sx={{ textDecoration: (invNo === 'Opening Balance' || String(invNo).trim() === 'Opening Balance') ? 'none' : 'underline' }}>
                                  {invNo}
                                </TableCell>
                                <TableCell >
                                  {type}
                                </TableCell>
                                <TableCell >
                                  {status}
                                </TableCell>
                           
                                <TableCell sx={{ textAlign: "right", textDecoration: 'underline !important',}}>
                                  {cr}
                                </TableCell>
                                <TableCell sx={{ textAlign: "right" }}>
                                  {dr}
                                </TableCell>
                                <TableCell sx={{ textAlign: "right" }}>
                                  {balanceFormatted}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* <Box > 
                      <TablePaginationCustom
                        count={customerLedger.length}
                        page={table.page}
                        rowsPerPage={table.rowsPerPage}
                        onPageChange={table.onChangePage}
                        onRowsPerPageChange={table.onChangeRowsPerPage}
                        labelDisplayedRows={({ from, to, count }) => `${from}-${to}${count !== -1 ? ` of ${count}` : ''}`}
                        className="pagination-styles"
                      />
                      </Box> */}
                  </Paper>
                )}
                {nodataRow && (
                  <Box sx={{ py: 3, textAlign: "left" }}>
                    <Typography sx={{ color: "#d32f2f", fontSize: "0.875rem" }}>
                      NO Transaction Available.
                    </Typography>
                  </Box>
                )}
                </Box>
              </>
            )}
            {activeTab === "received" && (
              <>
                <Paper
                >
                  {amountDueLoading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                      <CircularProgress size={40} />
                    </Box>
                  ) : (
                    <>
                      <TableContainer>
                        <Table
                          className="table-cell-border"
                          sx={{
                            tableLayout: "fixed",
                          }}
                        >
                          <TableHead>
                            <TableRow className="table-cell-header" sx={{

                            }}>
                              <TableCell sx={{ width: "80px", minWidth: "80px" }}>Sr. No.</TableCell>
                              <TableCell sx={{ minWidth: "280px", width: "280px" }}>Customer Name(Ac/No)</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "150px", minWidth: "150px" }}>C Balance</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "150px", minWidth: "150px" }}>Amount Due</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>0 to 30 Days</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>30 + Days</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>60 + Days</TableCell>
                              <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>90 + Days</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {amountDueCustomers.length === 0 ? (
                              <TableRow>
                                <TableCell colSpan={8} sx={{ textAlign: "center", py: 8 }}>
                                  <Typography sx={{ color: "#637381", fontSize: "0.75rem" }}>
                                    No data available
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            ) : (
                              amountDueCustomers.map((row, idx) => (
                                <TableRow
                                  key={idx}
                                  hover
                                  className="table-cell-style"
                                >
                                  <TableCell sx={{ width: "80px", minWidth: "80px" }}>
                                    {amountDuePage * amountDueRowsPerPage + idx + 1}
                                  </TableCell>
                                  <TableCell sx={{ minWidth: "280px", width: "280px" }}>
                                    {row.customer_name}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.cBalances || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.total_due || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.get_dues_zero_to_30 || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.get_dues_30 || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.get_dues_60 || 0).toFixed(2)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "right", width: "100px", minWidth: "100px" }}>
                                    {parseFloat(row.get_dues_90 || 0).toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              ))
                            )}
                          </TableBody>
                          <TableFooter>
                            <TableRow sx={{
                              backgroundColor: "#f5f7fa",
                              '& .MuiTableCell-root': {
                                fontSize: "0.75rem",
                                fontWeight: 600,
                                color: "#212b36",
                                textAlign: "right",
                              }
                            }}>
                              <TableCell colSpan={2} >
                                Total:
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.c_balance}
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.total_due}
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.zero_to_30}
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.thirty_plus}
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.sixty_plus}
                              </TableCell>
                              <TableCell >
                                {amountDueTotals.ninety_plus}
                              </TableCell>
                            </TableRow>
                          </TableFooter>
                        </Table>
                      </TableContainer>
                      <Box display="flex" justifyContent="flex-end" alignItems="center">
                        <TablePagination
                          component="div"
                          count={-1}
                          page={amountDuePage}
                          onPageChange={(e, newPage) => setAmountDuePage(newPage)}
                          rowsPerPage={amountDueRowsPerPage}
                          onRowsPerPageChange={(e) => {
                            setAmountDueRowsPerPage(parseInt(e.target.value, 10));
                            setAmountDuePage(0);
                          }}
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          labelDisplayedRows={({ from, to }) => `${from}-${to}`}
                          className="pagination-styles"
                        />
                      </Box>
                    </>
                  )}
                </Paper>
              </>
            )}
          </Box>

        </Paper>
      </Box>
      <Dialog
        open={showPaymentModal}
        onClose={() => {
          if (!isSubmittingPayment) {
            setShowPaymentModal(false);
          }
        }}
        disableEscapeKeyDown={isSubmittingPayment}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36" }}>
          Add Payment
        </DialogTitle>
        <form onSubmit={handleCustomerPaymentSubmit}>
          <DialogContent
            dividers
            sx={{
              overflow: "hidden",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
            }}
          >
            <Grid2 container spacing={2} pt={1}>
              <Grid2 size={{ xs: 12, md: 6 }} >
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Date *"
                    value={payDate ? moment(payDate) : null}
                    onChange={(newValue) => {
                      setPayDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                      setErrors((prev) => ({ ...prev, payDate: "" }));
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!errors.payDate,
                        helperText: errors.payDate,
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#f5f7fa",
                            fontSize: "0.875rem",
                            "&:hover": {
                              backgroundColor: "#fff",
                            },
                            "&.Mui-focused": {
                              backgroundColor: "#fff",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <FormControl fullWidth error={!!errors.paymentType}>
                  <InputLabel sx={{ fontSize: "0.875rem" }}>Paying by *</InputLabel>
                  <Select
                    value={paymentType}
                    onChange={handlePaymentTypeChange}
                    label="Paying by *"
                    sx={{
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                      },
                    }}
                  >
                    <MenuItem value="">Select Payment Type</MenuItem>
                    <MenuItem value="cash">Cash</MenuItem>
                    <MenuItem value="CC">Credit Card</MenuItem>
                    <MenuItem value="Cheque">Cheque</MenuItem>
                    <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                    <MenuItem value="UPI">UPI</MenuItem>
                    <MenuItem value="Credit Note">Credit Note</MenuItem>
                  </Select>
                  {errors.paymentType && (
                    <Typography sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: 0.5, ml: 1.75 }}>
                      {errors.paymentType}
                    </Typography>
                  )}
                </FormControl>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Amount *"
                  type="number"
                  fullWidth
                  value={payAmount}
                  onChange={(e) => {
                    setPayAmount(e.target.value);
                    setErrors((prev) => ({ ...prev, payAmount: "" }));
                  }}
                  error={!!errors.payAmount}
                  helperText={errors.payAmount}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </Grid2>
              {isChequeVisible && (
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <TextField
                    label="Cheque No *"
                    fullWidth
                    value={chequeNo}
                    onChange={(e) => {
                      setChequeNo(e.target.value);
                      setErrors((prev) => ({ ...prev, chequeNo: "" }));
                    }}
                    error={!!errors.chequeNo}
                    helperText={errors.chequeNo}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f7fa",
                        fontSize: "0.875rem",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </Grid2>
              )}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Reference"
                  fullWidth
                  value={reference}
                  onChange={(e) => setReference(e.target.value)}
                  
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </Grid2>
            </Grid2>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              onClick={() => setShowPaymentModal(false)}
              className="button-variant-outlined"
              variant="outlined"
              disabled={isSubmittingPayment}
            >
              Close
            </Button>
            <Button
              type="submit"
              variant="contained"
              className="button-variant-contained"
              disabled={isSubmittingPayment}
            >
              {isSubmittingPayment ? (
                <CircularProgress size={22} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={showDebitModal}
        onClose={() => setShowDebitModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36" }}>
          Add Debit Note
        </DialogTitle>
        <form onSubmit={handleDebitNoteSubmit}>
          <DialogContent
            dividers
            sx={{
              overflow: "hidden",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none",
            }}
          >
            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label="Date *"
                    value={payDate ? moment(payDate) : null}
                    onChange={(newValue) => {
                      setPayDate(newValue ? newValue.format("YYYY-MM-DD") : "");
                      setErrors((prev) => ({ ...prev, payDate: "" }));
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        error: !!errors.payDate,
                        helperText: errors.payDate,
                        sx: {
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "#f5f7fa",
                            fontSize: "0.875rem",
                            "&:hover": {
                              backgroundColor: "#fff",
                            },
                            "&.Mui-focused": {
                              backgroundColor: "#fff",
                            },
                          },
                          "& .MuiInputLabel-root": {
                            fontSize: "0.875rem",
                          },
                        },
                      },
                    }}
                  />
                </LocalizationProvider>
              </Grid2>
              {isChequeVisible && (
                <Grid2 size={{ xs: 12, md: 6 }}>
                  <TextField
                    label="Cheque No *"
                    fullWidth
                    value={chequeNo}
                    onChange={(e) => setChequeNo(e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "#f5f7fa",
                        fontSize: "0.875rem",
                        "&:hover": {
                          backgroundColor: "#fff",
                        },
                        "&.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      },
                      "& .MuiInputLabel-root": {
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </Grid2>
              )}
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Amount *"
                  type="number"
                  fullWidth
                  value={payAmount}
                  onChange={(e) => {
                    setPayAmount(e.target.value);
                    setErrors((prev) => ({ ...prev, payAmount: "" }));
                  }}
                  error={!!errors.payAmount}
                  helperText={errors.payAmount}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  label="Reference"
                  fullWidth
                  value={reference}
                  onChange={(e) => setReference(e.target.value)}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#f5f7fa",
                      fontSize: "0.875rem",
                      "&:hover": {
                        backgroundColor: "#fff",
                      },
                      "&.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.875rem",
                    },
                  }}
                />
              </Grid2>
            </Grid2>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button
              onClick={() => setShowDebitModal(false)}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                color: "#637381",
              }}
            >
              Close
            </Button>
            <Button
              type="submit"
              variant="contained"
              sx={{
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Dialog
        open={showAllocationModal}
        onClose={handleCloseAllocationModal}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
            maxHeight: '90vh',
            m: { xs: 1, sm: 2 }
          },
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 600,
          fontSize: { xs: '1rem', sm: '1.25rem' },
          px: 3,
          py: 1.5,
          mb: 2,
          borderBottom: '1px dashed #E0E0E0'
        }}>
          Invoice Payment Allocation
          <IconButton
            onClick={handleCloseAllocationModal}
            sx={{ color: 'text.secondary' }}
            size="small"
          >
            <Iconify icon="mdi:close" width={24} height={24} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            p: { xs: 1.5, sm: 3 },
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          <InvoicePaymentAllocation
            customer_id={allocationCustomerId}
            fromDate={dates[0] ? format(dates[0], "MM/dd/yyyy") : ""}
            toDate={dates[1] ? format(dates[1], "MM/dd/yyyy") : ""}
            onClose={handleCloseAllocationModal}
            onSuccess={() => {
              let startDate = dates[0] ? format(dates[0], "MM/dd/yyyy") : "";
              let endDate = dates[1] ? format(dates[1], "MM/dd/yyyy") : "";
              loadCustomerLadger(customerInputValue?.value, startDate, endDate);
              handleCloseAllocationModal();
            }}
            API_URL={API_URL}
            accessToken={accessToken}
            customerName={customerInputValue?.label || customer?.name}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={showPaymentDetailsModal}
        onClose={() => setShowPaymentDetailsModal(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "1rem", color: "#212b36", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          Payment Details
          <Stack direction="row" spacing={1} alignItems="center">
            <Button
            className="button-variant-contained"
              variant="contained"
              size="small"
              onClick={handleDownloadPaymentDetailsPDF}
              disabled={!paymentDetails || loadingPaymentDetails}
              startIcon={<Iconify icon="eva:download-fill" width={16} />}
              sx={{
                textTransform: "none",
                fontWeight: 500,
                boxShadow: "none",
              }}
            >
              Download PDF
            </Button>
            <IconButton onClick={() => setShowPaymentDetailsModal(false)} size="small" sx={{ color: "#637381" }}>
              <Iconify icon="eva:close-fill" width={20} />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            overflow: "hidden",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none",
          }}
        >
          {loadingPaymentDetails ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={40} />
            </Box>
          ) : paymentDetails ? (
            <Box>
              {paymentDetails.customer && (
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: 2,
                    border: "1px solid rgba(145, 158, 171, 0.16)",
                    p: 2,
                    mb: 3,
                  }}
                >
                  <TableContainer>
                    <Table>
                      <TableBody>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.75rem", fontWeight: 600, color: "#212b36", width: "40%" }}>
                            Customer Name(Account No):
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36", fontWeight: 600 }}>
                            {String(paymentDetails.customer.customer_account_no ?? "").trim()
                              ? `${paymentDetails.customer.customer_name}(${String(paymentDetails.customer.customer_account_no).trim()})`
                              : paymentDetails.customer.customer_name}
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                            Phone: <strong>{paymentDetails.customer.customer_phone}</strong>
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                            Email: <strong>{paymentDetails.customer.customer_email}</strong>
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                            Payment Amount: <strong>{parseFloat(paymentDetails.customer.payment_amount).toFixed(2)}</strong>
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                            Payment Date: <strong>{formatAllocationDate(paymentDetails.customer.payment_date)}</strong>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              )}
              <Typography sx={{ fontSize: "0.875rem", fontWeight: 600, color: "#212b36", mb: 2 }}>
                Allocations
              </Typography>
              {paymentDetails.allocations && paymentDetails.allocations.length > 0 ? (
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    border: "1px solid rgba(145, 158, 171, 0.16)",
                    borderRadius: 1,
                    maxHeight: "40vh",
                    overflow: "auto",
                  }}
                >
                  <Table className="table-cell-border" >
                    <TableHead>
                      <TableRow className="table-cell-header">
                        <TableCell>Allocation Date</TableCell>
                        <TableCell>Invoice No</TableCell>
                        <TableCell>Grand Total</TableCell>
                        <TableCell>Allocated Amount</TableCell>
                        <TableCell>Source</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paymentDetails.allocations.map((allocation, index) => (
                        <TableRow key={index}>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>
                            {formatAllocationDate(allocation.allocation_date)}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>{allocation.invoice_no}</TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36", textAlign: "right" }}>
                            {parseFloat(allocation.grand_total).toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36", textAlign: "right" }}>
                            {parseFloat(allocation.allocated_amount).toFixed(2)}
                          </TableCell>
                          <TableCell sx={{ fontSize: "0.75rem", color: "#212b36" }}>{allocation.source}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography sx={{ fontSize: "0.875rem", color: "#637381" }}>
                  {paymentDetails.message || "No allocations found for this payment"}
                </Typography>
              )}
            </Box>
          ) : (
            <Box sx={{ textAlign: "center", py: 4 }}>
              <Typography sx={{ fontSize: "0.875rem", color: "#637381" }}>No payment details available</Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
          variant="outlined"
          className="button-variant-outlined"
            onClick={() => setShowPaymentDetailsModal(false)}
            sx={{
              textTransform: "none",
              fontWeight: 500,
              color: "#637381",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomerAccounts;
